import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ClientUserBranchAccessValidationSchema } from "../../schemas/companyBranches/updateUserAccesses.schema";
import { ErrorResponse } from "@/common/types/errorResponse";
import { ClientUserBranchAccess } from "../../types/clientUserBranchAccess.type";

interface UseUpdateCompanyBranchUserAccessesProps {
  userBranchAccess?: ClientUserBranchAccess;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useUpdateCompanyBranchUserAccesses = ({ userBranchAccess, onSuccess, onError }: UseUpdateCompanyBranchUserAccessesProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateCompanyBranchUserAccesses', userBranchAccess?.id],
    mutationFn: (data: ClientUserBranchAccessValidationSchema) => {
      const payload = {
        user_branch_accesses_attributes: [
          {
            id: userBranchAccess?.id,
            branch_hierarchy_for_user_access: data.branch_hierarchy_for_user_access.value,
          }
        ]
      }

      return privateAxios.put(`/client/company_branches/${userBranchAccess?.branch?.id}/update_user_accesses`, {
        company_branch: payload,
      });
    },
    onSuccess,
    onError,
  });
}
